"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8456],{

/***/ 69589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68312);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30653);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ImgP__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98508);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);





 // import Button from "./ButtonNormal";







var Button = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 7911).then(__webpack_require__.bind(__webpack_require__, 77911));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(77911)];
    }
  }
});

var SpecialtyLube = function SpecialtyLube(_ref) {
  var _section_image$list, _section_image$list$, _section_image$list2, _section_image$list2$, _section_image$list3, _section_image$list3$, _section_image$list4, _section_image$list4$, _section_image$list5, _section_image$list5$;

  var offset = _ref.offset,
      img = _ref.img,
      data = _ref.data,
      no = _ref.no,
      winWidth = _ref.winWidth;
  var section_data = data === null || data === void 0 ? void 0 : data.section_data;
  var section_image = data === null || data === void 0 ? void 0 : data.images;
  var location = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    // Use GSAP to animate opacity from 0 to 1
    gsap__WEBPACK_IMPORTED_MODULE_6__/* .gsap.to */ .p8.to('.hide', {
      alpha: 1,
      visibility: 'visible',
      display: 'block',
      duration: 0.5,
      delay: 1
    });
  }, [location.pathname]); // Run this effect only once when the component mounts

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledLube, {
      offset: offset,
      className: "specialty-lube ",
      children: [section_image !== null && section_image !== void 0 && (_section_image$list = section_image.list) !== null && _section_image$list !== void 0 && (_section_image$list$ = _section_image$list[0]) !== null && _section_image$list$ !== void 0 && _section_image$list$.full_path ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_ImgP__WEBPACK_IMPORTED_MODULE_2__/* .Img */ .E, {
        src: section_image !== null && section_image !== void 0 && (_section_image$list2 = section_image.list) !== null && _section_image$list2 !== void 0 && (_section_image$list2$ = _section_image$list2[0]) !== null && _section_image$list2$ !== void 0 && _section_image$list2$.full_path ? section_image === null || section_image === void 0 ? void 0 : (_section_image$list3 = section_image.list) === null || _section_image$list3 === void 0 ? void 0 : (_section_image$list3$ = _section_image$list3[0]) === null || _section_image$list3$ === void 0 ? void 0 : _section_image$list3$.full_path : 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/shanta-easytrade/1686937289h8eHd.webp',
        alt: 'Shanta Securities Limited',
        objectFit: 'cover',
        layout: 'fill'
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_ImgP__WEBPACK_IMPORTED_MODULE_2__/* .Img */ .E, {
        src: section_image !== null && section_image !== void 0 && (_section_image$list4 = section_image.list) !== null && _section_image$list4 !== void 0 && (_section_image$list4$ = _section_image$list4[0]) !== null && _section_image$list4$ !== void 0 && _section_image$list4$.full_path ? section_image === null || section_image === void 0 ? void 0 : (_section_image$list5 = section_image.list) === null || _section_image$list5 === void 0 ? void 0 : (_section_image$list5$ = _section_image$list5[0]) === null || _section_image$list5$ === void 0 ? void 0 : _section_image$list5$.full_path : 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/shanta-easytrade/1686937289h8eHd.webp',
        alt: 'Shanta Securities Limited',
        objectFit: 'cover',
        layout: 'fill'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            sm: 10,
            children: section_data !== null && section_data !== void 0 && section_data.subtitle && no == false ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h2", {
              className: 'split-up',
              children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(section_data !== null && section_data !== void 0 && section_data.subtitle ? section_data === null || section_data === void 0 ? void 0 : section_data.subtitle : 'Want to explore new opportunities?')
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h2", {
              className: '',
              children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(section_data !== null && section_data !== void 0 && section_data.subtitle ? section_data === null || section_data === void 0 ? void 0 : section_data.subtitle : 'Want to explore new opportunities?')
            })
          }), winWidth && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "bottom-text-wrap ",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
              sm: 9,
              className: 'cta',
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                className: "bottom-text-wrap__box",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h4", {
                  className: '',
                  children: section_data !== null && section_data !== void 0 && section_data.short_desc ? section_data === null || section_data === void 0 ? void 0 : section_data.short_desc : 'Attain financial freedom at the tip of your fingertips?'
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Button, {
                  icon: true,
                  src: 'contact',
                  width: '200',
                  hoverBackground: '#221F1F',
                  background: 'transparent',
                  color: '#fff',
                  text: 'Contact Us'
                })]
              })
            })
          })]
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyleMobile, {
      children: winWidth < 767 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: "bottom-text-wrap ",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
          sm: 9,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: "bottom-text-wrap__box",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h4", {
              className: '',
              children: section_data !== null && section_data !== void 0 && section_data.short_desc ? section_data === null || section_data === void 0 ? void 0 : section_data.short_desc : 'Want to explore new opportunities?'
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(Button, {
              icon: true,
              src: 'contact',
              width: '200',
              hoverBackground: '#221F1F',
              background: 'transparent',
              color: '#fff',
              text: 'Contact Us'
            })]
          })
        })
      }) : ''
    })]
  });
};

var StyledLube = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "CTA-v3__StyledLube",
  componentId: "sc-xno92b-0"
})(["position:relative;padding-top:100px;padding-bottom:120px;.hide{display:none;}h2{color:#ffffff;margin:0 0 90px 0;}@media (min-width:1550px){padding-top:250px;padding-bottom:250px;.bottom-text-wrap__box{padding-top:calc(76.5714%) !important;min-height:300px !important;max-width:30%;min-width:400px !important;h4{top:50px !important;left:50px !important;right:50px !important;}.dc-btn{left:50px !important;bottom:50px !important;}}.bottom-text-wrap{bottom:-140px !important;}}p{font-size:16px;line-height:22px;font-weight:600;margin:0;color:#ffffff;}.bottom-text-wrap{position:absolute;left:", "px;bottom:-110px;z-index:9;&__box{background-color:", ";padding-top:calc(268 / 270 * 100%);max-width:25%;min-height:220px;bottom:0px;position:absolute;min-width:320px;h4{font-family:", ";color:#ffffff;margin:0;font-size:20px;line-height:28px;font-weight:500;position:absolute;top:40px;left:40px;right:40px;}.dc-btn{position:absolute;left:40px;bottom:40px;}}}@media (max-width:1150px){.bottom-text-wrap__box{h4{font-size:25px;line-height:28px;}}}@media (max-width:1020px){.bottom-text-wrap{.col-sm-6{min-width:100% !important;margin:0;p{margin-bottom:40px;}}}}@media (max-width:767px){padding:125px 0 !important;.bottom-text-wrap{position:relative;left:unset;right:unset;bottom:unset;width:100%;.col-sm-9{padding-right:0;padding-left:0;}}.bottom-text-wrap__box{position:relative;left:unset;right:unset;bottom:unset;width:100%;max-width:100%;min-height:unset;height:auto !important;min-width:100%;padding-top:60%;}h2{margin:0;}}@media (max-width:600px){padding-top:60px;h1{margin-bottom:38px;font-size:32px;line-height:36px;font-weight:600;}.bottom-text-wrap .col-sm-3{max-width:calc(100% - 50px);min-width:calc(100% - 50px);.bottom-text-wrap__box{height:270px;padding-top:0;h4{font-size:32px;line-height:36px;}}}}@media (max-width:350px){.bottom-text-wrap .col-sm-3{min-width:100%;}}@media (min-width:1500px){.bottom-text-wrap__box{padding-top:calc(268 / 350 * 100%);}}"], function (props) {
  return props.offset ? props.offset - 15 : '0';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .hover */ .Mr);
var StyleMobile = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "CTA-v3__StyleMobile",
  componentId: "sc-xno92b-1"
})(["display:none;.bottom-text-wrap{&__box{background-color:", ";h4{font-family:", ";color:#ffffff;margin:0;font-size:20px;line-height:28px;font-weight:500;position:absolute;top:40px;left:40px;right:40px;}.dc-btn{position:absolute;left:40px;bottom:40px;}}}@media (max-width:767px){display:block;.bottom-text-wrap{position:relative;left:unset;right:unset;bottom:unset;width:100%;.col-sm-9{padding-right:0;padding-left:0;}}.bottom-text-wrap__box{position:relative;left:unset;right:unset;bottom:unset;width:100%;max-width:100%;min-height:unset;height:auto !important;min-width:100%;min-height:200px;}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_11__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(SpecialtyLube));

/***/ }),

/***/ 77791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31555);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68312);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var MyComponent = function MyComponent(_ref) {
  var background = _ref.background,
      data = _ref.data;
  var section_data = data === null || data === void 0 ? void 0 : data.section_data;
  var section_image = data === null || data === void 0 ? void 0 : data.images;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledComponent, {
    background: background,
    className: 'quotes pb-200 pt-200 as-image-text-slider',
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          md: {
            span: 9,
            offset: 1
          },
          children: [(section_data === null || section_data === void 0 ? void 0 : section_data.description) && (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(section_data === null || section_data === void 0 ? void 0 : section_data.description), (section_data === null || section_data === void 0 ? void 0 : section_data.subtitle) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
            className: 'author',
            children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(section_data === null || section_data === void 0 ? void 0 : section_data.subtitle)
          })]
        })
      })
    })
  });
};

var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Quotes__StyledComponent",
  componentId: "sc-k3mavy-0"
})(["overflow:hidden;background-color:", ";h3{font-size:60px;font-weight:500 !important;line-height:72px;color:#3C3C3B;span{color:", ";}}.author{text-align:right;font-size:20px;font-weight:500;margin-top:10px;}"], function (p) {
  return p.background ? p.background : '#FFF';
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_9__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(MyComponent));

/***/ }),

/***/ 13810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68777);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Img = function Img(_ref) {
  var src = _ref.src,
      visible = _ref.visible,
      speed = _ref.speed,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  // const smoother = useContext(SmootherContext);
  //
  // useEffect(() => {
  //     smoother.effects("img", {speed: "auto"})
  // }, [])
  var DefaultBanner = '/images/static/blurbg.svg';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledImg, {
    className: "global-image  ",
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: src && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
      alt: alt || 'Shanta Securities Limited',
      src: src || DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ImgP__StyledImg",
  componentId: "sc-3jyf6w-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";overflow:hidden;img{width:100%;height:120svh;object-fit:", ";position:absolute;top:0;left:0;right:0;bottom:0;will-change:transform;@media(max-width:767px){height:100% !important;}}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 87820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97346);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36981);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30653);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(68312);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87536);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22920);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25317);
/* harmony import */ var _ImgP__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13810);
/* harmony import */ var _pages_api_network_ApiServices__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92495);
/* harmony import */ var _pages_api_redux_home__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92806);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var Subscribe = function Subscribe(_ref) {
  var _section_image$list, _section_image$list$, _section_image$list2, _section_image$list2$, _formState$errors, _formState$errors$ema;

  var img = _ref.img,
      text = _ref.text,
      data = _ref.data,
      no = _ref.no;
  var section_data = data === null || data === void 0 ? void 0 : data.section_data;
  var section_image = data === null || data === void 0 ? void 0 : data.images;
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
  var responseData = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function (state) {
    return state.homeReducer;
  });

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .useForm */ .cI)({
    mode: 'all'
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      formState = _useForm.formState,
      reset = _useForm.reset; //--- form submit


  var success = function success(msg) {
    return react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.success */ .Am.success(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var error = function error(msg) {
    return react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .Am.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined
    });
  };

  var handleBlur = function handleBlur() {// Perform onBlur logic here
  };

  var handleChange = function handleChange() {// Perform onChange logic here
  };

  var tl = new gsap__WEBPACK_IMPORTED_MODULE_11__/* .TimelineLite */ .Vq();

  var onSubmit = function onSubmit(e) {
    var api_services = _pages_api_network_ApiServices__WEBPACK_IMPORTED_MODULE_7__/* .ApiServices.ADDSUBSCRIP */ .u.ADDSUBSCRIP;
    var formData = new FormData();
    formData.append('email', e === null || e === void 0 ? void 0 : e.email);

    if (e.email !== '') {
      dispatch((0,_pages_api_redux_home__WEBPACK_IMPORTED_MODULE_8__/* .postForm */ .Md)([api_services, formData])); // success('Successfully Submitted')

      reset();
    }
  };

  var count = 0;

  var onError = function onError(errors) {
    Object.values(errors).forEach(function (error) {
      count++;
    });

    if (count > 0) {
      react_toastify__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .Am.error('Fill out the correct inputs');
    }

    count = 0;
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.error) !== '') {
      var _responseData$error;

      error(responseData === null || responseData === void 0 ? void 0 : (_responseData$error = responseData.error) === null || _responseData$error === void 0 ? void 0 : _responseData$error.message);
    }

    if (responseData && (responseData === null || responseData === void 0 ? void 0 : responseData.success) !== '') {
      success(responseData === null || responseData === void 0 ? void 0 : responseData.success);
    }
  }, [responseData]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledSubscribe, {
    className: "subscribe   pt-160  pb-160 ",
    children: [(section_image === null || section_image === void 0 ? void 0 : (_section_image$list = section_image.list) === null || _section_image$list === void 0 ? void 0 : (_section_image$list$ = _section_image$list[0]) === null || _section_image$list$ === void 0 ? void 0 : _section_image$list$.full_path) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_ImgP__WEBPACK_IMPORTED_MODULE_6__/* .Img */ .E, {
        src: section_image === null || section_image === void 0 ? void 0 : (_section_image$list2 = section_image.list) === null || _section_image$list2 === void 0 ? void 0 : (_section_image$list2$ = _section_image$list2[0]) === null || _section_image$list2$ === void 0 ? void 0 : _section_image$list2$.full_path,
        alt: 'Shanta Securities Limited',
        layout: 'fill',
        objectFit: 'cover'
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          sm: 6,
          className: 'box',
          children: [no ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h2", {
            className: '',
            children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(section_data === null || section_data === void 0 ? void 0 : section_data.short_desc)
          }) : (section_data === null || section_data === void 0 ? void 0 : section_data.short_desc) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h2", {
            className: '',
            children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(section_data === null || section_data === void 0 ? void 0 : section_data.short_desc)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            className: "",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("input", {
              name: 'spam_protector',
              type: "hidden"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Group */ .Z.Group, {
              className: "form-group",
              controlId: "formBasicEmail",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Control */ .Z.Control, _objectSpread(_objectSpread({
                className: formState !== null && formState !== void 0 && (_formState$errors = formState.errors) !== null && _formState$errors !== void 0 && (_formState$errors$ema = _formState$errors.email) !== null && _formState$errors$ema !== void 0 && _formState$errors$ema.message ? 'has-error form-control-lg' : 'form-control-lg'
              }, register("email", {
                required: {
                  value: true,
                  message: 'Email is required'
                },
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Enter a valid Email'
                }
              })), {}, {
                type: "email",
                placeholder: "Your Email Address*"
              })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                className: "dc-btn-submit",
                onClick: handleSubmit(onSubmit, onError),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                  width: '100',
                  text: 'Subscribe',
                  color: '#3C3C3B',
                  hoverBackground: _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_16__/* .hover */ .Mr,
                  background: '#ED1B34'
                })
              })]
            })]
          })]
        })
      })
    })]
  });
};

var StyledSubscribe = styled_components__WEBPACK_IMPORTED_MODULE_17__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Newsletter__StyledSubscribe",
  componentId: "sc-1cbt91u-0"
})(["position:relative;overflow:hidden;.parent-div{padding-top:100%;position:absolute;left:0;right:0;bottom:0;top:0;}h2{font-family:", ";color:#ffffff;font-size:44px;font-weight:500;line-height:56px;margin:0 0 54px 0;}.form-group{position:relative;.form-control{height:45px;background-color:transparent;border-radius:40px;font-size:16px;font-weight:500;padding-left:30px;color:#FFFFFF;autocomplete:off;::placeholder{color:rgba(255,255,255,0.5);font-size:16px;font-weight:500;outline:none;border:none;}:focus{outline:none;outline-color:transparent;border-color:white;}}.dc-btn-submit{position:absolute;top:0;right:0;.dc-btn{height:45px;}a{display:flex;height:100%;width:100%;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;font-size:16px;font-weight:500;margin:0px;line-height:18px;color:#3C3C3B;text-transform:capitalize;border:none;background-color:#FFFFFF;letter-spacing:0px;position:relative;border-radius:30px;overflow:hidden;span{}}}}@media(max-width:767px){.form-group .form-control{padding-left:18px;color:rgb(255,255,255);padding-top:10px;}}input:-webkit-autofill{-webkit-text-fill-color:#fff !important;border:1px solid #FFFFFF;&:hover{border:1px solid #FFFFFF;}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_16__/* .title */ .TN);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Subscribe));

/***/ })

}]);